// extracted by mini-css-extract-plugin
export default {"wrapper":"AuthLayout_wrapper__2SQry","logo":"AuthLayout_logo__2xmC7"};